import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_FAILURE, AUTH_LOGOUT, AUTH_SERVICE_ERROR, TOKEN_REFRESH, TOKEN_REFRESH_SUCCESS } from '../actions/auth'

import { Config } from "aws-sdk"
import { CognitoUserPool, AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js"

const ClientId =  "3j93cbs1vok12istprkj1pav27";
const UserPoolId = "eu-west-2_nhPfQFjLh"

const state = { 
	status: String,
	token: localStorage.getItem(`CognitoIdentityServiceProvider.${ClientId}.dev.idToken`) || '',
	refreshToken: localStorage.getItem(`CognitoIdentityServiceProvider.${ClientId}.dev.refreshToken`) || '',
	errorMessage: ''
}

const getters = {
	authIsAuthenticated: state => !!state.token,
	authToken: state => state.token,
	authStatus: state => state.status,
	getAuthErrorMessage: state => state.errorMessage,
}

const actions = {
	[AUTH_REQUEST]: ({commit}, credentials) => {

		/*=============================================
		=            AWS COGNITO            =
		=============================================*/

		Config.region = "eu-west-2";
		var userpool = new CognitoUserPool({
			UserPoolId: UserPoolId,
			ClientId: ClientId
		});

		var userData = {
			Username: credentials.username,
			Pool: userpool
		}

		var authData = new AuthenticationDetails({
			Username: credentials.username,
			Password: credentials.password
		});

		var cognitoUser = new CognitoUser(userData);

		cognitoUser.authenticateUser(authData, {
			onSuccess:  ( result ) => {	
				commit(AUTH_SUCCESS, result);
			},
			
			onFailure: ( error ) => {
				commit(AUTH_FAILURE, error );
			}

		});
		
	},

	[TOKEN_REFRESH]: ({commit}) => {
		
		return new Promise((resolve, reject) => {

			var userPool = new CognitoUserPool({
				UserPoolId: UserPoolId,
				ClientId: ClientId
			});
			
			var cognitoUser = userPool.getCurrentUser();

			cognitoUser.getSession(function(err, session){
				if (!err){

					var refreshToken = session.getRefreshToken(); 

					cognitoUser.refreshSession(refreshToken, (err, session) => {
						if (err) {
							reject(err);
						} else {
							commit(TOKEN_REFRESH_SUCCESS, session)
							resolve()
						}
					});
				}else{

					reject(err);

				}

			})

		})

	},

	[AUTH_SERVICE_ERROR]: ({commit}, error) => {
		commit(AUTH_FAILURE, error)
	}

  }

const mutations = {

	[AUTH_REQUEST]: (state) => {
		state.status = 'loading'
	},

	[AUTH_SUCCESS]: (state, payload) => {
		state.status = 'success'
		state.token = payload.idToken.jwtToken
		localStorage.setItem("idExpires",payload.idToken.payload.exp)
	},

	[TOKEN_REFRESH_SUCCESS]: (state, session) => {
		state.status = 'success'
		state.token = session.idToken.jwtToken
		localStorage.setItem("idExpires",session.idToken.payload.exp)
	},

	[AUTH_ERROR]: (state) => {
		state.status = 'error'
	},
	
	[AUTH_FAILURE]: (state, payload ) => {
		state.status = 'fail'
		state.errorMessage = payload.message
		localStorage.clear();
		state.token = ''
	},

	[AUTH_LOGOUT]: (state) => {
		state.token = ''
	}
}

export default {
	state,
	getters,
	actions,
	mutations,
}
   